const importRunFilters = {
  clientId: null,
  source: null,
  statusId: null,
  startedOnOrAfter: null,
  startedBefore: null
}

export default () => Object.assign({}, importRunFilters)
